export enum SortOptions {
  SORT_ALPHABETICAL = 'sort__alphabetical',
  SORT_BY_FLIGHT_TIMES = 'sort__flight_times'
}

export enum SortDirection {
  ASC = 'ascending',
  DESC = 'descending'
}
